import type { IDataAccessor } from "@core/data-access";
import { AbstractAccessorService } from "@core/data-access";
import type { IResponse } from "@core/data-access/model";
import type { ICurrencyRestService} from "./currency-rest";
import type { ICurrency } from "@modules/website/model/domain/currency";


export class CurrencyRestService extends AbstractAccessorService<ICurrency> implements ICurrencyRestService {
    public readonly $name = "currencyRestService";
    public static readonly $inject: string[] = ["$accessor"];
    constructor(public $accessor: IDataAccessor<ICurrency>) {
        super();
    }

    public verify(currencyCode: string):angular.IPromise<IResponse<boolean>>{
        return this.$accessor<boolean, any, string>(this.$name, "verify", { "parameter": { "currencyCode": currencyCode } });
    }

}